import Slate from 'slate'
import { List, Range } from 'immutable'
import { TABLE_BLUE } from '../../../../colors'

import TablePosition from 'slate-edit-table/dist/TablePosition'

const headerTextMarks = Slate.Mark.createSet([
  {
    type: 'color',
    data: { color: 'white' },
  },
  {
    type: 'bold',
  },
])

export function insertTable(transform) {
  // adds a paragraph for after the table, then adds table
  transform.collapseToEndOfNextBlock()
  transform.insertBlock('paragraph')
  transform.collapseToEndOfPreviousBlock()
  transform.insertBlock(
    Slate.Block.create({
      type: 'table',
      nodes: [
        {
          type: 'table_row',
          nodes: [
            {
              type: 'table_cell',
              nodes: [
                {
                  type: 'paragraph',
                  kind: 'block',
                  ranges: [],
                  nodes: [Slate.Text.createFromString(' ', headerTextMarks)],
                },
              ],
              data: {
                backgroundColor: TABLE_BLUE,
              },
            },
            {
              type: 'table_cell',
              nodes: [
                {
                  type: 'paragraph',
                  kind: 'block',
                  ranges: [],
                  nodes: [Slate.Text.createFromString(' ', headerTextMarks)],
                },
              ],
              data: {
                backgroundColor: TABLE_BLUE,
              },
            },
          ],
        },
        {
          type: 'table_row',
          nodes: [
            {
              type: 'table_cell',
              nodes: [
                {
                  type: 'paragraph',
                  kind: 'block',
                  ranges: [],
                  nodes: [Slate.Text.createFromString('')],
                },
              ],
            },
            {
              type: 'table_cell',
              nodes: [
                {
                  type: 'paragraph',
                  kind: 'block',
                  ranges: [],
                  nodes: [Slate.Text.createFromString('')],
                },
              ],
            },
          ],
        },
      ],
    }),
  )
  return transform
}

export function removeTable(transform) {
  const { state } = transform
  // Target the table cell that contains the paragraph where the selection actually is
  const tableCell = state.document
    .getAncestors(state.anchorKey)
    .find(({ type }) => type === 'table_cell')

  const pos = TablePosition.create(state, tableCell)
  const { table } = pos

  return transform.deselect().removeNodeByKey(table.key)
}

export function insertColumn(transform) {
  const { state } = transform
  const tableCell = state.document
    .getAncestors(state.anchorKey)
    .find(({ type }) => type === 'table_cell')

  const pos = TablePosition.create(state, tableCell)
  const { table } = pos
  const at = pos.getColumnIndex() + 1

  // Insert the new cells
  table.nodes.forEach((row, i) => {
    const newCell = Slate.Block.create(
      // if creating the header row, colour the background and text
      i === 0
        ? {
            type: 'table_cell',
            data: { backgroundColor: TABLE_BLUE },
            nodes: [
              {
                type: 'paragraph',
                kind: 'block',
                ranges: [],
                nodes: [Slate.Text.createFromString(' ', headerTextMarks)],
              },
            ],
          }
        : // otherwise, create a regular cell
          {
            type: 'table_cell',
            nodes: [
              {
                type: 'paragraph',
                kind: 'block',
                ranges: [],
                nodes: [Slate.Text.createFromString('')],
              },
            ],
          },
    )
    transform = transform.insertNodeByKey(row.key, at, newCell)
  })

  // Update alignment
  let align = List(table.data.get('align'))
  align = align.insert(at, 'left')
  transform = transform.setNodeByKey(table.key, {
    data: { align },
  })
  // Update the selection (not doing can break the undo)
  transform.collapseToEndOf(tableCell).moveOffsetsTo(state.startOffset)
  return transform
}

export function removeColumn(transform) {
  const { state } = transform
  const tableCell = state.document
    .getAncestors(state.anchorKey)
    .find(({ type }) => type === 'table_cell')

  const pos = TablePosition.create(state, tableCell)
  const { table } = pos
  const at = pos.getColumnIndex()

  const rows = table.nodes

  // Remove the cell from every row
  if (pos.getWidth() > 1) {
    rows.forEach(row => {
      const cell = row.nodes.get(at)
      transform.removeNodeByKey(cell.key)
    })

    // Update alignment
    let align = List(table.data.get('align'))
    align = align.delete(at)
    transform = transform.setNodeByKey(table.key, {
      data: { align },
    })
  } else {
    // If last column, clear text in cells instead
    rows.forEach(row => {
      row.nodes.forEach(cell => {
        cell.nodes.forEach(node => {
          // We clear the texts in the cells
          transform.removeNodeByKey(node.key)
        })
      })
    })
  }

  // Replace the table
  return transform
}

export function insertRow(transform) {
  const { state } = transform
  const tableCell = state.document
    .getAncestors(state.anchorKey)
    .find(({ type }) => type === 'table_cell')

  const pos = TablePosition.create(state, tableCell)
  const { table } = pos
  const at = pos.getRowIndex() + 1

  // Create a new row with the right count of cells
  const columns = table.nodes.get(0).nodes.size
  const cellNodes = Range(0, columns)
    .map(() =>
      Slate.Block.create({
        type: 'table_cell',
        nodes: [
          {
            type: 'paragraph',
            kind: 'block',
            ranges: [],
            nodes: [Slate.Text.createFromString('')],
          },
        ],
      }),
    )
    .toList()

  const newRow = Slate.Block.create({
    type: 'table_row',
    nodes: cellNodes,
  })

  return transform
    .insertNodeByKey(table.key, at, newRow)
    .collapseToEndOf(newRow.nodes.get(pos.getColumnIndex()))
}

export function removeRow(transform) {
  const { state } = transform
  const tableCell = state.document
    .getAncestors(state.anchorKey)
    .find(({ type }) => type === 'table_cell')

  const pos = TablePosition.create(state, tableCell)
  const { table } = pos
  const at = pos.getRowIndex()

  const row = table.nodes.get(at)
  // Update table by removing the row
  if (pos.getHeight() > 1) {
    transform.removeNodeByKey(row.key)
  } else {
    // If last remaining row, clear it instead
    row.nodes.forEach(cell => {
      cell.nodes.forEach(node => {
        transform.removeNodeByKey(node.key)
      })
    })
  }

  return transform
}



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Table/Transforms.js